var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fondo"},[_c('landing'),_c('contador'),_c('servicios'),_c('cloud'),_c('eko')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }